const statusMessages = {
  BROKER_HAS_NOT_PAID: 'Tu cuenta ha sido bloqueada por falta de pago',
  BROKER_BROKE_CODE_OF_ETHICS: 'Tu cuenta ha sido bloqueada por violación al código de ética'
}

export const getMessage = (hasPaid, userStatus, blockedReason) => {
  if (!hasPaid) {
    return 'Completa tu pago para poder acceder'
  }
  if (userStatus === 'PENDING') {
    return 'Tu cuenta aún no está activada'
  }
  if (userStatus === 'ACTIVE') {
    return ''
  }
  return statusMessages[blockedReason]
}
